import {Button, IconButton} from '@wandb/components';
import React from 'react';

import {Analytics} from '../../../services/analytics';
import {useStatsigGateWorkspaceColumnEditorRedesign as useNewTableEditor} from '../../../util/rampFeatureFlags';
import {ConfigV2} from '../../../util/runfeed';
import {ModalTriggerButton} from '../../elements/ModalTriggerButton';
import {useRunSelectorFeatureEnabled} from '../RunSelectorFeaturesContext';
import {RunsTableEditor} from '../TableEditor/RunsTableEditor';

type WBTableActionsProps = {
  expandable?: boolean;
  expanded?: boolean;
  extraTableActionsLeft?: React.ReactNode;
  extraTableActionsRight?: React.ReactNode;
  extraTableActionsTop?: React.ReactNode;
  fixedColumns: string[];
  isInReport?: boolean;
  setTableSettings: (config: ConfigV2) => void;
  tableSettings: ConfigV2;
};

export function WBTableActions({
  expandable,
  expanded,
  extraTableActionsLeft,
  extraTableActionsRight,
  extraTableActionsTop,
  fixedColumns,
  isInReport,
  setTableSettings,
  tableSettings,
}: WBTableActionsProps) {
  const isEnabled = useRunSelectorFeatureEnabled();
  const newTableEditor = useNewTableEditor();
  const buttonIcon = 'column';
  const buttonText = 'Columns';

  const button = expanded ? (
    <Button variant="secondary" startIcon={buttonIcon}>
      {buttonText}
    </Button>
  ) : (
    <IconButton
      aria-label={buttonText}
      icon={buttonIcon}
      variant="secondary"
      tooltip={{children: buttonText}}
    />
  );

  const modalContent = (
    <RunsTableEditor
      fixedColumns={fixedColumns}
      config={tableSettings}
      update={setTableSettings}
    />
  );

  const showRightSideControls = !expandable || expanded;

  // Show the column editor button if:
  // 1. The table feature is not disabled
  // 2. The table is expanded, and the right side controls are shown, OR
  // 3. The new table editor feature flag is enabled
  const showColumnEditor =
    isEnabled('edit-cols') && (showRightSideControls || newTableEditor);

  return (
    <div className="wb-table-actions-wrapper">
      <span className="wb-table-actions-top">{extraTableActionsTop}</span>
      <div className="wb-table-actions">
        <div style={{display: 'flex', gap: 8}}>{extraTableActionsLeft}</div>
        <div style={{display: 'flex', gap: 8}}>
          {showRightSideControls ? extraTableActionsRight : null}
          {showColumnEditor ? (
            <ModalTriggerButton
              buttonElement={button}
              modalHeader="Manage columns"
              modalContent={modalContent}
              onClick={() => {
                const actionLocation = isInReport ? 'report' : 'runs table';
                Analytics.track('Columns button clicked', {
                  location: actionLocation,
                });
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
